const content = {
  title: "About The club",
  description: {
    en:
      "<p><strong>The Group’s signature homeowners programme</strong><br><br><strong>The Santuary Club</strong> offers members a chance to enjoy a luxury lifestyle and explore a range of new destinations and experiences worldwide</p>",
    cn:
      "<p><strong>该会所针对集团会员业主开放，</strong> 提供奢华生活体验，<br>带领会员去往新目的地，提供国际化的全新体验</p>",
    ru:
      "<p><strong>Sanctuary Club,</strong><br><br>эксклюзивная программа для собственников, предоставляет ее участникам возможность наслаждаться роскошью и открывать для себя новые места и впечатления по всему миру.</p>",
  },
};

export default {
  content,
};



// WEBPACK FOOTER //
// ./src/data/SanctuaryClub/about.js